import React, { createContext, FC, ReactNode } from 'react';

import { useVehiclesWorkflowStatusQuery, VehicleStatus, WorkflowStatusDescription } from '../types/api.graphql';

type Nullable<T> = T | null;

type ChangeTypeOfKeys<T extends object, Keys extends keyof T, NewType> = {
  [key in keyof T]: key extends Keys ? NewType : T[key];
};

export type NarrowWorkflowStatusDescription = ChangeTypeOfKeys<
  WorkflowStatusDescription,
  'key' | 'name',
  VehicleStatus
>;

interface WorkflowContextProps {
  statuses: Nullable<NarrowWorkflowStatusDescription[]>;
  loading: boolean;
}

interface WorkflowProviderProps {
  children: ReactNode;
}

const defaultStatus = {
  key: VehicleStatus.Opportunity,
  name: VehicleStatus.Opportunity,
};

const WorkflowContext = createContext<WorkflowContextProps>({ statuses: [defaultStatus], loading: null });

export const WorkflowProvider: FC<WorkflowProviderProps> = ({ children }) => {
  const { data, loading } = useVehiclesWorkflowStatusQuery();

  return (
    <WorkflowContext.Provider
      value={{
        statuses: (data?.vehiclesWorkflowStatus as Array<NarrowWorkflowStatusDescription>) || [defaultStatus],
        loading: loading || null,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflowContext: () => WorkflowContextProps = () => {
  return React.useContext(WorkflowContext);
};
